import { gql, useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { FRAGMENT_PRODUCT_LINE_DETAIL } from "./graphql";
import ProductLineForm from "./ProductLineForm";

const FETCH_PRODUCT_LINE_DETAIL = gql`
  query FETCH_PRODUCT_LINE_DETAIL($id: ID!) {
    productLine(id: $id) {
      ...productLine
    }
  }
  ${FRAGMENT_PRODUCT_LINE_DETAIL}
`;

const ProductLineLoader = ({ id = null, ...rest }) => {
  const { loading, error, data } = useQuery(FETCH_PRODUCT_LINE_DETAIL, {
    variables: { id },
    skip: id === null,
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  return (
    <ProductLineForm
      id={id}
      fetchedProductLine={data ? data.productLine : null}
      {...rest}
    />
  );
};

export default ProductLineLoader;
